import { render, staticRenderFns } from "./TypicalCaseDetail.vue?vue&type=template&id=fedd07b8&scoped=true&"
import script from "./TypicalCaseDetail.vue?vue&type=script&lang=js&"
export * from "./TypicalCaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./TypicalCaseDetail.vue?vue&type=style&index=0&id=fedd07b8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fedd07b8",
  null
  
)

export default component.exports